<template>
  <div>
    <v-btn
      class="ml-4 d-none d-sm-inline-flex"
      small
      :outlined="!online"
      :color="online ? 'error' : 'primary'"
      :title="online ? 'ปิดจอลูกค้า' : 'เปิดจอลูกค้า'"
      @click="$emit('click')"
    >
      {{ online ? 'ปิด • จอลูกค้า' : 'เปิด • จอลูกค้า' }}
      <v-icon right>{{ online ? 'mdi-monitor-off' : 'mdi-monitor' }}</v-icon>
    </v-btn>
    <div v-if="showReminder" class="ml-4 mt-1 red--text text-caption">
      กรุณาเปิดจอลูกค้า หากต้องการ
    </div>
    <!-- Permtang Helper is only offered when a second screen is detected: that is what it is for. -->
    <div v-if="secondScreen" class="ml-4 mt-2 d-flex align-center" data-testid="helper-download-row">
      <v-btn small outlined color="primary" :href="helperDownloadHref" :download="helperDownloadFilename" title="ดาวน์โหลดโปรแกรมจัดการหน้าจอ (Permtang Helper) สำหรับ Windows (รองรับรีโมท F13/F14/F15 และอุปกรณ์ให้คะแนน)">
        โหลด โปรแกรมจัดการหน้าจอ
        <v-icon right small>mdi-download</v-icon>
      </v-btn>
      <v-tooltip bottom max-width="280">
        <template v-slot:activator="{ on }">
          <v-icon class="ml-1" small color="grey darken-1" v-on="on">mdi-information-outline</v-icon>
        </template>
        Permtang Helper สำหรับ Windows ดาวน์โหลดแล้วเปิดได้ทันที
        รองรับรีโมทให้คะแนน F13/F14/F15 และอุปกรณ์ USB
        หาก Windows แสดงคำเตือน ให้ดูวิธีเปิดโปรแกรมครั้งแรก
      </v-tooltip>
    </div>
    <div v-if="secondScreen" class="ml-4 mt-1">
      <a :href="helperGuideHref" target="_blank" rel="noopener" class="helper-guide-link" data-testid="helper-guide-link">
        วิธีเปิดโปรแกรมครั้งแรก
      </a>
    </div>
  </div>
</template>

<script>
// TEMPORARY (Vuetify 2). `online` is true while a display window is alive.
// `showReminder` is true once: a second screen was detected and this device
// still hasn't opened the display, 1 minute after the page loaded.
//
// `secondScreen` (window.screen.isExtended: true when the computer has more than one
// screen) decides whether the Permtang Helper download -- and its guide link -- is shown
// at all. It needs no permission prompt and no page-specific data, so it is computed here
// rather than passed in by the 5 Detail.vue pages that use this button. It is re-read when
// the browser reports a screen change (plugging in / removing a monitor), and is false in
// browsers that do not implement isExtended.
//
// The one download offered here is Permtang Helper. The .exe itself is built
// in a separate repo (customer-display-helper/, see its README "Architecture
// boundary") -- only the already-built download artifact is hosted here, at
// public/download/ (see firebase.json's rewrite exclusion for that path),
// together with helper-version.json, which the Helper reads to update itself.
//
// It's hosted under a .dat extension, not .exe: Firebase Hosting's Spark
// (free) plan rejects the whole deploy with "Executable files are
// forbidden on the Spark billing plan" if ANY file in the deploy ends in
// .exe, regardless of path -- confirmed by a real failed deploy. The
// `download` attribute below tells the browser to save the fetched .dat
// file locally under the real .exe filename, so this is invisible to the
// customer; only the hosted URL differs from the saved file.
const detectSecondScreen = () => typeof window !== 'undefined' && !!(window.screen && window.screen.isExtended);

const HELPER_DOWNLOAD_FILENAME = 'PermtangHelper.exe';
const HELPER_HOSTED_FILENAME = 'PermtangHelper.dat';

export default {
  props: {
    online: { type: Boolean, default: false },
    showReminder: { type: Boolean, default: false }
  },
  data: () => ({
    secondScreen: detectSecondScreen(),
    helperDownloadHref: `/download/${HELPER_HOSTED_FILENAME}`,
    helperDownloadFilename: HELPER_DOWNLOAD_FILENAME,
    // Optional first-run guide (public page); opens in a new tab, never required before downloading.
    helperGuideHref: '/customer-display/helper-guide'
  }),
  mounted() {
    const screen = typeof window !== 'undefined' ? window.screen : null;
    if (screen && typeof screen.addEventListener === 'function') {
      this.onScreenChange = () => { this.secondScreen = detectSecondScreen(); };
      screen.addEventListener('change', this.onScreenChange);
    }
  },
  beforeDestroy() {
    const screen = typeof window !== 'undefined' ? window.screen : null;
    if (screen && this.onScreenChange && typeof screen.removeEventListener === 'function') {
      screen.removeEventListener('change', this.onScreenChange);
    }
  }
};
</script>

<style scoped>
/* Secondary to the download button above it: small, plain link. */
.helper-guide-link { font-size: 0.9rem; }
</style>
